import { render, staticRenderFns } from "./inner_box_label.vue?vue&type=template&id=b85104a0&scoped=true"
import script from "./inner_box_label.vue?vue&type=script&lang=js"
export * from "./inner_box_label.vue?vue&type=script&lang=js"
import style0 from "./inner_box_label.vue?vue&type=style&index=0&id=b85104a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85104a0",
  null
  
)

export default component.exports